import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Linkedin, Facebook, Instagram, Twitter, Youtube, MessageCircle } from 'lucide-react';
import { contactData } from '../data/mockData';
import { locaties } from '../data/locaties';

const Footer = () => {
  return (
    <footer className="bg-[#0d1b2a] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_staffforce-new-site/artifacts/8pffcrsv_image.png"
                alt="StaffingForce"
                className="h-8 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Het A-merk voor opdrachtgevers en kandidaten op het gebied van Finance & HR. Duurzaam detacheren sinds 2007.
            </p>
            <div className="flex gap-3 flex-wrap">
              {contactData.linkedin && (
                <a
                  href={contactData.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#00897B] transition-colors duration-300"
                >
                  <Linkedin size={18} />
                </a>
              )}
              {contactData.facebook && (
                <a
                  href={contactData.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#00897B] transition-colors duration-300"
                >
                  <Facebook size={18} />
                </a>
              )}
              {contactData.instagram && (
                <a
                  href={contactData.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#E1306C] transition-colors duration-300"
                >
                  <Instagram size={18} />
                </a>
              )}
              {contactData.twitter && (
                <a
                  href={contactData.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="X (Twitter)"
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-black transition-colors duration-300"
                >
                  <Twitter size={18} />
                </a>
              )}
              {contactData.youtube && (
                <a
                  href={contactData.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#FF0000] transition-colors duration-300"
                >
                  <Youtube size={18} />
                </a>
              )}
              <a
                href={`https://wa.me/${contactData.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#25D366] transition-colors duration-300"
              >
                <MessageCircle size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Navigatie</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-400 hover:text-[#00bfa5] transition-colors text-sm">Home</Link></li>
              <li><Link to="/over-ons" className="text-gray-400 hover:text-[#00bfa5] transition-colors text-sm">Over ons</Link></li>
              <li><Link to="/diensten" className="text-gray-400 hover:text-[#00bfa5] transition-colors text-sm">Diensten</Link></li>
              <li><Link to="/vacatures" className="text-gray-400 hover:text-[#00bfa5] transition-colors text-sm">Vacatures</Link></li>
              <li><Link to="/voor-kandidaten" className="text-gray-400 hover:text-[#00bfa5] transition-colors text-sm">Voor Kandidaten</Link></li>
              <li><Link to="/voor-opdrachtgevers" className="text-gray-400 hover:text-[#00bfa5] transition-colors text-sm">Voor Opdrachtgevers</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-[#00bfa5] transition-colors text-sm">Blog</Link></li>
              <li><Link to="/veelgestelde-vragen" className="text-gray-400 hover:text-[#00bfa5] transition-colors text-sm">Veelgestelde vragen</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-[#00bfa5] transition-colors text-sm">Contact</Link></li>
            </ul>
          </div>

          {/* Office Amsterdam */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Kantoor Amsterdam</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="text-[#00bfa5] mt-0.5 flex-shrink-0" />
                <div className="text-sm text-gray-400">
                  <p>{contactData.offices[0].address}</p>
                  <p>{contactData.offices[0].postalCode}</p>
                  <p>{contactData.offices[0].building}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={16} className="text-[#00bfa5] flex-shrink-0" />
                <span className="text-sm text-gray-400">{contactData.offices[0].phone}</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={16} className="text-[#00bfa5] flex-shrink-0" />
                <a href={`mailto:${contactData.offices[0].email}`} className="text-sm text-gray-400 hover:text-[#00bfa5] transition-colors">{contactData.offices[0].email}</a>
              </div>
            </div>
          </div>
        </div>

        {/* SEO Locations row */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-4">
            Detachering in heel Nederland
          </h3>
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            {locaties.map((loc) => (
              <Link
                key={loc.slug}
                to={`/locaties/${loc.slug}`}
                className="text-gray-500 hover:text-[#00bfa5] text-xs transition-colors"
              >
                {loc.stad}
              </Link>
            ))}
            <Link
              to="/locaties"
              className="text-[#00bfa5] hover:text-white text-xs font-semibold transition-colors"
            >
              Alle locaties →
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Staffing Force. Alle rechten voorbehouden.
          </p>
          <div className="flex gap-6">
            <a href="/privacy" className="text-gray-500 hover:text-[#00bfa5] text-sm transition-colors">Privacy</a>
            <a href="#" className="text-gray-500 hover:text-[#00bfa5] text-sm transition-colors">Voorwaarden</a>
            <a href="#" className="text-gray-500 hover:text-[#00bfa5] text-sm transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
